module.exports = __webpack_public_path__ + "static/img/wz-doctor.ad5c3c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/wz-doctor.svg
// module id = 3Efj
// module chunks = 15